import type { AppDispatch } from "../../store";
import * as reducer from "./slice";

export const createApiDispatchers = (dispatch: AppDispatch) => ({
	dispatchSetApi: (name: string, payload: any, body: any) => {
		dispatch(
			reducer.set({
				name,
				value: payload,
				body,
			}),
		);
	},

	dispatchErrorApi: () => {
		dispatch(reducer.error());
	},

	dispatchStartApi: () => {
		dispatch(reducer.start());
	},

	dispatchResetAPI: (value?: any) => {
		dispatch(reducer.reset(value));
	},
});
